import * as S from "../LegendItem.style";
import { ReactComponent as IconSpeed } from "../../../../styles/assets/svg/icon_speed.svg";
import { ReactComponent as IconWind } from "../../../../styles/assets/svg/icon_wind.svg";
import { ReactComponent as IconPitch } from "../../../../styles/assets/svg/icon_pitch.svg";
import { ReactComponent as IconRolling } from "../../../../styles/assets/svg/icon_rolling.svg";

interface LegendItemProps {
  iconType?: "speed" | "wind" | "pitch" | "rolling";
  title: string;
  value?: any;
}

export const StatusLegendItem = ({
  iconType,
  title,
  value,
}: LegendItemProps) => {
  return (
    <S.LegendItem $legendType="status">
      <S.LegendIcon>
        {iconType === "speed" && <IconSpeed />}
        {iconType === "wind" && <IconWind />}
        {iconType === "pitch" && <IconPitch />}
        {iconType === "rolling" && <IconRolling />}
        <S.LegendTit>{title}</S.LegendTit>
      </S.LegendIcon>
      <S.LegendValue>{value ? value : "-"}</S.LegendValue>
    </S.LegendItem>
  );
};
